import {ThemeProvider} from "@material-ui/core/styles"
import PropTypes from "prop-types"
import React, {useState} from "react"
import {Switch} from "react-router"
import {withRouter} from "react-router-dom"
import {theme} from "./helpers/theme"

import {isEmpty} from "lodash"
import {connect} from "react-redux"
import {GuestNavigation, UserNavigation} from "~/components/"
import GuestRoute from "~/components/routes/GuestRoute"
import UserRoute from "~/components/routes/UserRoute"
import {logout} from "./actions/authActions"
import FlashMessagesList from "./components/flash/FlashMessagesList"
import {InfotextProvider} from "./context/InfoTextContext"
import {ShoppingCartProvider} from "./context/ShoppingCartContext"
import "./styles/index.css"
import * as Views from "./views/"

const App = props => {
  const [infotexts, setInfotexts] = useState([])

  function logout(e) {
    e.preventDefault()
    props.logout()
  }

  function renderNavigation() {
    return isEmpty(props.user) ? (
      <GuestNavigation />
    ) : (
      <UserNavigation user={props.user} logout={logout} />
    )
  }

  function renderContent() {
    if (isEmpty(props.user)) {
      return (
        <Switch>
          <GuestRoute exact path="/" component={Views.LoginView} />
          <GuestRoute exact path="/login" component={Views.LoginView} />
          <GuestRoute
            exact
            path="/forgot_password"
            component={Views.ForgotPasswordView}
          />
          <GuestRoute
            path="/password_reset/:reset_password_token"
            component={Views.ResetPasswordView}
          />
        </Switch>
      )
    } else {
      return (
        <Switch>
          <UserRoute exact path="/" component={Views.HomeView} />
          <UserRoute exact path="/users" component={Views.UsersView} />
          <UserRoute exact path="/users/new" component={Views.NewUserView} />
          <UserRoute
            exact
            path="/tenants/:tenant/users/new"
            component={Views.NewUserView}
          />
          <UserRoute
            exact
            path="/tenants/:tenant/users/:user_id"
            component={Views.NewUserView}
          />

          <UserRoute exact path="/products" component={Views.ProductsView} />
          <UserRoute
            exact
            path="/articles/stock_out/:article_barcode"
            component={Views.ArticleStockOutView}
          />
          <UserRoute
            exact
            path="/articles/move/:article_barcode"
            component={Views.ArticleMovementView}
          />
          <UserRoute
            exact
            path="/articles/stock_up/:article_barcode"
            component={Views.ArticleStockUpView}
          />
          <UserRoute
            exact
            path="/product/:product_id"
            component={Views.ProductDetailView}
          />
          <UserRoute
            exact
            path="/products/new"
            component={Views.NewProductView}
          />
          <UserRoute
            exact
            path="/products/:product_id"
            component={Views.NewProductView}
          />
          <UserRoute exact path="/articles" component={Views.ArticlesView} />
          <UserRoute
            exact
            path="/article/:article_barcode"
            component={Views.ArticleDetailView}
          />
          <UserRoute
            exact
            path="/articles/:article_barcode"
            component={Views.NewArticleView}
          />
          <UserRoute exact path="/warehouse" component={Views.WarehouseView} />
          <UserRoute
            exact
            path="/area/:area_id"
            component={Views.AreaDetailView}
          />
          <UserRoute exact path="/areas/new" component={Views.NewAreaView} />
          <UserRoute
            exact
            path="/areas/:area_id"
            component={Views.NewAreaView}
          />
          <UserRoute
            exact
            path="/location/:location_barcode"
            component={Views.LocationDetailView}
          />
          <UserRoute
            exact
            path="/order_history/:order_id"
            component={Views.OrderDetailView}
          />
          <UserRoute
            exact
            path="/locations/new"
            component={Views.NewLocationView}
          />
          <UserRoute
            exact
            path="/locations/:location_barcode"
            component={Views.NewLocationView}
          />
          <UserRoute
            exact
            path="/settings/:tenant"
            component={Views.SettingsView}
          />
          <UserRoute
            exact
            path="/shopping_cart"
            component={Views.ShoppingCartView}
          />
          <UserRoute
            exact
            path="/inventories/:tenant"
            component={Views.InventoriesView}
          />
          <UserRoute
            exact
            path="/destinations"
            component={Views.DestinationsView}
          />
          <UserRoute
            exact
            path="/destination/:destination_id"
            component={Views.DestinationDetailView}
          />
          <UserRoute
            exact
            path="/destinations/new"
            component={Views.NewDestinationView}
          />
          <UserRoute
            exact
            path="/destinations/:destination_id"
            component={Views.NewDestinationView}
          />
          <UserRoute
            exact
            path="/transactions"
            component={Views.TransactionsView}
          />
          <UserRoute
            exact
            path="/delivery_notes"
            component={Views.DeliveryNotesView}
          />
          <UserRoute
            exact
            path="/delivery_notes/:delivery_note_number"
            component={Views.DeliveryNoteDetailView}
          />
          <UserRoute
            exact
            path="/delivery_notes/:delivery_note_number/pdf"
            component={Views.DeliveryNotePdfView}
          />
          <UserRoute
            exact
            path="/transaction/:transaction_type/:transaction_id"
            component={Views.TransactionDetailView}
          />

          <UserRoute exact path="/tenants" component={Views.TenantsView} />
          <UserRoute
            exact
            path="/tenants/:tenantName"
            component={Views.TenantDetailView}
          />
          <UserRoute exact path="/new_tenant" component={Views.NewTenantView} />
        </Switch>
      )
    }
  }

  return (
    <ShoppingCartProvider>
      <ThemeProvider theme={theme}>
        <InfotextProvider>
          <div className="wrapper">
            <FlashMessagesList messages />
            <div className="contentWrapper">
              {renderNavigation()}

              <div className="content">{renderContent()}</div>
            </div>
          </div>
        </InfotextProvider>
      </ThemeProvider>
    </ShoppingCartProvider>
  )
}

App.propTypes = {
  logout: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired
}

const mapStateToProps = ({router, auth}) => {
  const {location} = router
  const {user} = auth
  return {
    location,
    user
  }
}

export default withRouter(connect(mapStateToProps, {logout})(App))



// WEBPACK FOOTER //
// ./src/App.js